import axios from 'src/utils/axios';

type DVOpts = { actingOnMemberId?: number | null };

function dvPath(path: string, opts: DVOpts): string {
  return opts.actingOnMemberId
    ? `data-vault/members/${opts.actingOnMemberId}/profile-survey/${path}`
    : `profile-survey/${path}`;
}

export interface ProfileSurveyDTO {
  id: number;
  is_profile: boolean;
  certification_config_id: number;
  compliance_started_date: string;
}

export const getProfileSurvey = (
  opts: DVOpts = {}
): Promise<ProfileSurveyDTO> =>
  axios.get<ProfileSurveyDTO>(dvPath('', opts)).then((r) => r.data);
